import { Result, Spin, Layout, Menu } from "antd";
import { observer } from "mobx-react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { useStores } from "../../../store";
import { __ } from "../../../utils";
import { AccountAffiliateSignUp, AccountAffiliateHeader } from ".";
const {
  Content,
  Sider
} = Layout;
const AccountAffiliateLayout = observer(() => {
  const {
    accountStore
  } = useStores();
  const {
    session
  } = accountStore;
  const navigate = useNavigate();
  const [,, tab = ""] = useLocation().pathname.split("/");
  if (!session) {
    return null;
  }
  const {
    affiliateError,
    affiliate,
    canSignUpAsAffiliate
  } = session;
  if (!affiliate && !affiliateError) {
    // One of both must be given
    return null;
  }
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: !!(session !== null && session !== void 0 && session.busy)
  }, canSignUpAsAffiliate ? /*#__PURE__*/React.createElement(AccountAffiliateSignUp, null) : affiliateError ? /*#__PURE__*/React.createElement(Result, {
    subTitle: affiliateError.message,
    status: affiliateError.hasErrorCode("AffiliateStatusIsPending") ? "info" : "warning"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccountAffiliateHeader, null), /*#__PURE__*/React.createElement(Layout, {
    style: {
      background: "transparent",
      marginTop: 15
    }
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Layout, {
    style: {
      background: "transparent"
    }
  }, /*#__PURE__*/React.createElement(Sider, {
    width: 200,
    breakpoint: "md"
  }, /*#__PURE__*/React.createElement(Menu, {
    mode: "inline",
    style: {
      height: "100%"
    },
    selectedKeys: [tab],
    onSelect: _ref => {
      let {
        key
      } = _ref;
      navigate(`/affiliate/${key}`);
    },
    items: [{
      key: "",
      label: __("Transactions")
    }, {
      key: "links",
      label: __("Link generator")
    }, {
      key: "coupons",
      label: __("Coupons")
    }, {
      key: "payouts",
      label: __("Payouts")
    }, {
      key: "edit",
      label: __("Invoice & payment data")
    }]
  })), /*#__PURE__*/React.createElement(Content, {
    style: {
      padding: "0 0 0 15px",
      minHeight: 280
    }
  }, /*#__PURE__*/React.createElement(Outlet, null)))))));
});
export { AccountAffiliateLayout };